import type { LocalData } from './types';

// Same sessionStorage key as the legacy app so an in-place swap keeps existing
// sessions working.
const AUTH_SESSION_KEY = 'auth_key';

export function saveState(data: LocalData | null | undefined): void {
    if (!data) return;
    sessionStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(data));
}

export function removeState(): void {
    sessionStorage.removeItem(AUTH_SESSION_KEY);
}

export function loadState(): LocalData | undefined {
    const raw = sessionStorage.getItem(AUTH_SESSION_KEY);
    if (raw === null) return undefined;
    try {
        return JSON.parse(raw) as LocalData;
    } catch {
        return undefined;
    }
}
